import { convertDateFields as baseConvertDateFields } from './date-field-converter';

export function convertDateFields(object: Object, fieldNames?: string[]) {
    baseConvertDateFields(object, ['created', 'modified', 'deleted']
        .concat(fieldNames !== undefined ? fieldNames : []));
}
